import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'motors-listing-details-field-section',
    templateUrl: './motors-listing-details-field-section.component.html',
    styleUrls: ['./motors-listing-details-field-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MotorsListingDetailsFieldSectionComponent {}
